const EntityName = Object.freeze({
  Forecast: "Forecast",
  History: "History",
});

export default EntityName;
